import React, { useMemo, useState } from "react";
import s from "./ads_styles/AdsSearch.module.css";

export default function AdsPagination({ page, totalPages, onPageChange, totaltext }) {
  const [goto, setGoto] = useState("");

  const pages = useMemo(() => {
    const tp = Math.max(0, Number(totalPages) || 0);
    const cur = Math.min(Math.max(1, Number(page) || 1), Math.max(1, tp));

    if (tp <= 10) return Array.from({ length: tp }, (_, i) => i + 1);

    let start = Math.max(cur - 5, 1);
    let end = start + 9;
    if (end > tp) {
      end = tp;
      start = Math.max(end - 9, 1);
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }, [page, totalPages]);

  const tp = Math.max(0, Number(totalPages) || 0);
  const cur = Math.min(Math.max(1, Number(page) || 1), Math.max(1, tp));

  const jump = () => {
    const n = Number(goto);
    if (!Number.isFinite(n)) return;
    const clamped = Math.min(Math.max(1, Math.trunc(n)), Math.max(1, tp));
    onPageChange(clamped);
    setGoto("");
  };

  if (tp <= 1) {
    return (
      <div className={s.pagination}>
        <p>{totaltext || ""}</p>
      </div>
    );
  }

  return (
    <div className={s.pagination}>
      <button onClick={() => onPageChange(1)} disabled={cur === 1}>
        « В начало
      </button>
      <button onClick={() => onPageChange(cur - 1)} disabled={cur === 1}>
        Назад
      </button>

      {pages.map((num) => (
        <button
          key={num}
          onClick={() => onPageChange(num)}
          className={num === cur ? s.activePage : ""}
          aria-current={num === cur ? "page" : undefined}
        >
          {num}
        </button>
      ))}

      <button onClick={() => onPageChange(cur + 1)} disabled={cur === tp}>
        Вперёд
      </button>
      <button onClick={() => onPageChange(tp)} disabled={cur === tp}>
        В конец »
      </button>

      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginLeft: 8 }}>
        <span>Перейти:</span>
        <input
          type="number"
          min={1}
          max={tp}
          value={goto}
          onChange={(e) => setGoto(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && jump()}
          style={{ width: 70 }}
        />
        <button onClick={jump}>OK</button>
      </div>

      <p>{totaltext || ""}</p>
    </div>
  );
}
